export default function getRequestHolidayLeft(holidayHoursLeft: number) {
  const daysLeft = Math.floor(holidayHoursLeft / 8);
  const hoursLeft = holidayHoursLeft % 8;

  if (hoursLeft === 0) {
    return `${daysLeft}d`;
  }

  if (daysLeft === 0) {
    return `${hoursLeft}h`;
  }

  return `${daysLeft}d ${hoursLeft}h`;
}
